import { TextField } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div`
  padding-top: ${(props) => props.theme.spacing()}px;
  display: flex;
  flex-direction: column;
`;

export const Challenge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: ${(props) => props.theme.spacing()}px;
  padding-right: ${(props) => props.theme.spacing()}px;
  p {
    margin: 0px 5px;
    font-weight: bold;
  }

  @media screen and (min-width: 0px) and (max-width: 480px) {
    margin-top: ${(props) => 3 * props.theme.spacing()}px;
  }
`;

export const StyledText = styled.p`
  ${(props) => props.theme.newTypography.textStyleBodySemibold}
  margin: 8px 0;
  width: 100%;
`;

export const ChallengeInput = styled(TextField)<{ direction?: string }>`
  border-radius: 5px;
  border-width: 1px;
  font-weight: bold;
  font-size: 15px;
  height: 40px;
  width: 80px;

  direction: ${(props) => props.direction};

  & .MuiInputBase-input.Mui-disabled {
    box-shadow: inset 0 0 0 2px
      ${(props) => props.theme.newPalette.turquoise.T300};
    outline: none;
    border-radius: 5px;
  }

  /** Hiding the number arrows so the number is actually centered */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

export const IconContainer = styled.div`
  display: flex;
`;
